export default {
  methods: {
    build_includes(array, type) {
      return array.map(item => {
        return { type, id: item };
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/APIMixin.js